module.exports = "<div #whiteboard>\n</div>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/wb/graphic/graphic-wb.component.html
// module id = ../../../../../src/app/wb/graphic/graphic-wb.component.html
// module chunks = main